import { useEffect, useMemo, useState } from "react";
import { useRecoilValue } from "recoil";
import { pubState } from "../../recoil/pub.atom";
import {
  PageHeader,
  PageWrapper,
  SolutionHeaderWrapper,
  SolutionContentWrapper,
  SolutionHeaderInfoWrapper,
  SolutionHeaderButtonWrapper,
  SolutionCalenderWrapper,
} from "./style";
import { SettlementTournament } from "../../api/settlement";
import PointPaidPopup from "./components/point-paid";
import ExpenditurePopup from "./components/expenditure";
import ReportPage from "./components/report";
import ManualPointPopup from "./components/manualPoint";
import TournamentPopup from "./components/tournament";
import ReportCalender from "./components/calender/report-calender";
import { SolutionTable } from "./components/solution-table/solution-table";
import { SolutionPoint } from "./components/solution-table/solution-point";
import { SolutionHeader } from "./components/solution-header";
import SolutionHistory from "./components/history";
import MileagePopup from "./components/mileage";
import MenuManage from "./components/mileage/components/buy/components/menu-manage";
import { useSettlement } from "./hooks/use-settlement";
import { getDateWith9AMRule } from "../../utils/date";
import { WideState } from "../../recoil/wide";
import MobileSolution from "./components/mobile";
import DepositPopup from "./components/deposit";
import { Overlay } from "../../styles/popup";
import SolutionAllMilageHistory from "./components/mileage/components/all-history";
import { useNavigate } from "react-router-dom";
import { PubOwnerDomain, PubOwnerRole } from "../../api/cafe";

const Solution = () => {
  const hook = useSettlement();
  const {
    tournamentList,
    expenseList,
    setExpenseList,
    expenditure,
    date,
    setDate,
    data,
    // 데이터 호출
    getSettlementData,
  } = hook;
  const pub = useRecoilValue(pubState);
  const [selectedTournament, setSelectedTournament] =
    useState<SettlementTournament | null>(null);
  const [isManualPoint, setIsManualPoint] = useState<boolean>(false);
  const [isTournamentPopup, setIsTournamentPopup] = useState<boolean>(false);
  const [isPointPaidPopup, setIsPointPaidPopup] = useState<boolean>(false);
  const [isExpenditurePopup, setIsExpenditurePopup] = useState<boolean>(false);
  const [isDepositPopup, setIsDepositPopup] = useState<boolean>(false);
  const [isHistory, setIsHistory] = useState<boolean>(false);
  const [isMilageHistory, setIsMilageHistory] = useState<boolean>(false);
  const [historyType, setHistoryType] = useState<string>("");
  const [isReport, setIsReport] = useState<boolean>(false);
  const [isMileage, setIsMileage] = useState<boolean>(false);
  const [calenderOpen, setCalenderOpen] = useState<boolean>(false);
  const isWide = useRecoilValue(WideState);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!pub) {
      navigate("/");
      return;
    }
    if (pub.role === PubOwnerRole.OWNER || pub.domains.length === 0) return;
    if (!pub?.domains.includes(PubOwnerDomain.SETTLEMENT)) {
      navigate("/");
      alert("해당 페이지 접근 권한이 없습니다. ");
      return;
    }
  }, [navigate, pub]);

  const isPopup = useMemo(() => {
    if (
      isExpenditurePopup ||
      isHistory ||
      isManualPoint ||
      isMileage ||
      isPointPaidPopup ||
      isTournamentPopup ||
      isDepositPopup ||
      isMilageHistory
    )
      return true;
    return false;
  }, [
    isExpenditurePopup,
    isHistory,
    isManualPoint,
    isMileage,
    isPointPaidPopup,
    isTournamentPopup,
    isDepositPopup,
    isMilageHistory,
  ]);

  const handleTournamentPopup = (item: SettlementTournament) => {
    setIsTournamentPopup(true);
    setSelectedTournament(item);
  };

  const handlePointPaidPopup = (item: SettlementTournament) => {
    setSelectedTournament(item);
    setIsPointPaidPopup(true);
  };

  const handleHistoryOpen = (type: string) => {
    if (type === "MILEAGE") {
      setIsMilageHistory(true);
      return;
    }
    setIsHistory(true);
    setHistoryType(type);
  };

  const handleReport = () => {
    if (!isReport) {
      setIsReport(true);
    } else {
      setIsReport(false);
      setDate(getDateWith9AMRule());
    }
  };

  const handleOrderManagement = () => {
    //주문 관리 용 새창 500 * 1000 크기로 열기
    window.open("/order-management", "_blank", "width=500,height=600");
  };

  const handleOrderMenuManagement = () => {
    setMenuOpen(true);
  };

  if (!isWide) {
    return <MobileSolution hook={hook} />;
  }

  return (
    <PageWrapper onClick={() => setCalenderOpen(false)}>
      {isMileage && (
        <MileagePopup
          onClose={() => {
            setIsMileage(false);
            getSettlementData();
          }}
        />
      )}
      {isHistory && (
        <SolutionHistory
          onClose={() => {
            setIsHistory(false);
          }}
          type={historyType}
          data={data}
          dailyDate={date}
        />
      )}
      {isMilageHistory && (
        <SolutionAllMilageHistory
          onClose={() => {
            setIsMilageHistory(false);
          }}
          dailyDate={date}
        />
      )}
      {isTournamentPopup && (
        <TournamentPopup
          tournament={selectedTournament}
          onClose={() => {
            setIsTournamentPopup(false);
          }}
        />
      )}
      {isManualPoint && (
        <ManualPointPopup
          onClose={() => {
            setIsManualPoint(false);
            getSettlementData();
          }}
          transactionPoint={data?.transactionPoint || 0}
          weeklyTransactionPoint={data?.weeklyTransactionPoint || 0}
        />
      )}
      {isPointPaidPopup && (
        <PointPaidPopup
          tournamentId={selectedTournament?.tournamentId || 0}
          getData={getSettlementData}
          onClose={() => {
            setIsPointPaidPopup(false);
          }}
        />
      )}
      {isExpenditurePopup && (
        <ExpenditurePopup
          setSettlementExpenseList={setExpenseList}
          dailyDate={date}
          settlementExpenseList={expenseList}
          onClose={() => {
            setIsExpenditurePopup(false);
          }}
        />
      )}
      {isDepositPopup && (
        <DepositPopup
          onClose={() => {
            setIsDepositPopup(false);
          }}
        />
      )}
      <PageHeader>
        <div className="title">정산</div>
        <SolutionHeaderInfoWrapper>
          <SolutionHeaderButtonWrapper>
            <div
              className="button"
              onClick={() => {
                handleReport();
              }}
            >
              {isReport ? "돌아가기" : "정산 리포트"}
            </div>
          </SolutionHeaderButtonWrapper>
        </SolutionHeaderInfoWrapper>
      </PageHeader>
      {isReport ? (
        <ReportPage setIsReport={setIsReport} setDailyDate={setDate} />
      ) : (
        <>
          <SolutionHeaderWrapper>
            <SolutionCalenderWrapper>
              <ReportCalender
                dailyDate={date}
                setDailyDate={setDate}
                calenderOpen={calenderOpen}
                setCalenderOpen={setCalenderOpen}
                getData={getSettlementData}
                type={"dashboard"}
              />
              <img
                onClick={(e: any) => {
                  e.stopPropagation();
                  setCalenderOpen(!calenderOpen);
                }}
                src="/image-web/solution/arrow.svg"
                alt="icon"
              />
            </SolutionCalenderWrapper>
            <SolutionHeader
              data={data}
              expenditure={expenditure}
              handleExpenditurePopup={() => setIsExpenditurePopup(true)}
              settlementExpenseList={expenseList}
            />
          </SolutionHeaderWrapper>
          <SolutionContentWrapper>
            <SolutionPoint
              title="매장 이용권"
              data={data}
              handleManualPoint={() => setIsManualPoint(true)}
              handleHistoryOpen={handleHistoryOpen}
              date={date}
              type="POINT"
              handleDepositPopup={() => setIsDepositPopup(true)}
            />
            <SolutionPoint
              title="크레딧"
              allList={tournamentList}
              data={data}
              handleHistoryOpen={handleHistoryOpen}
              date={date}
              type="SEED"
            />
            <SolutionPoint
              title="캐럿"
              allList={tournamentList}
              data={data}
              handleHistoryOpen={handleHistoryOpen}
              date={date}
              type="CARROT"
            />
            <SolutionPoint
              title="주류 마일리지"
              allList={tournamentList}
              data={data}
              handleHistoryOpen={handleHistoryOpen}
              date={date}
              type="MILEAGE"
              handleMileageFun={{
                handleManualPopup: () => setIsMileage(true),
                handleOrderManagement: handleOrderManagement,
                handleOrderMenuManagement: handleOrderMenuManagement,
              }}
            />

            <SolutionTable
              allList={tournamentList}
              pub={pub}
              handlePointPaidPopup={handlePointPaidPopup}
              handleTournamentPopup={handleTournamentPopup}
            />
            {menuOpen && (
              <MenuManage
                onClose={() => {
                  setMenuOpen(false);
                }}
              />
            )}
          </SolutionContentWrapper>
        </>
      )}
      {isPopup && <Overlay />}
    </PageWrapper>
  );
};

export default Solution;
